class CurrentTimeController {
    constructor() {}

}
  
angular.module('transactionsApp').component('currentTime', {
    template: ( '<div ng-show="$root.showSyncBatch">Current Time Configured: {{$root.showTime}}</div>'),
    controller: ['$rootScope', CurrentTimeController]
});
